<template>
  <div>
    <v-fade-transition class="wrapper scroll-box layout align-center wrap justify-start">
      <div v-if="status && status.actions" class="wrapper scroll-box">
        <v-fade-transition leave-absolute class="layout align-center justify-start" group>
          <v-slide-item v-for="action in status.actions" :key="action._id">
            <core-button
              :disabled="blocked"
              flat
              class="mr-3"
              :secondary="action.priority === 'secondary'"
              :color="action.color"
              not-rounded
              :is-loading="isLoading"
              :label="action.name"
              @click="runAction(action._id)"
            />
          </v-slide-item>
        </v-fade-transition>
        <div v-show="blocked" class="meta layout align-center">
          <v-icon class="mr-2" x-small>mdi-lock</v-icon>
          <div>
            <span>Actions disabled because the asset will be updated</span>
            <span v-if="blockedBy">
              by
              <div>
                <user-chip :uid="blockedBy" />
              </div>
            </span>
          </div>
        </div>
      </div>
      <div v-else-if="$apollo.queries.status.loading">Loading...</div>
      <div v-else>Not able to load actions.</div>
    </v-fade-transition>
  </div>
</template>

<script>
import CoreButtonVue from '../buttons/CoreButton.vue';
import UserChipVue from '../UserChip.vue';
import gql from 'graphql-tag';
import { runAction } from '../../../services/graph/workflow.graph';
import { open_deep_link } from '@/utils/open_deep_link';
export default {
  name: 'StatusEngine',
  components: {
    coreButton: CoreButtonVue,
    userChip: UserChipVue
  },
  props: {
    initialStatus: {
      required: true,
      type: String
    },
    isBlocked: Boolean,
    blockedBy: {
      type: String
    },
    initialWorkflowStatus: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      blocked: this.isBlocked,
      status: {
        name: null,
        color: null,
        actions: []
      },
      icons: {
        locked: 'mdi-lock'
      },
      isLoading: false
    };
  },
  watch: {
    isBlocked: function(val) {
      this.blocked = val;
    }
  },

  methods: {
    async runAction(actionId) {
      this.isLoading = true;
      try {
        const result = await runAction({
          slideId: this.$route.query.asset,
          actionId
        });

        if (result && result.hookResults) {
          result.hookResults.forEach(result => {
            if (result.hookName === 'start_working') {
              const token = localStorage.getItem('token') || 'null';
              const iss = localStorage.getItem('iss') || 'null';
              open_deep_link({ ...result.value, token, iss });
            }
          });
        }
        await this.$store.dispatch('slides/reloadActiveSlide');
        this.$apollo.queries.status.refetch();
      } catch (e) {
        await this.$store.dispatch('alerts/warning', 'Not able to run action. Please retry.');
      } finally {
        this.isLoading = false;
      }
    }
  },
  apollo: {
    $subscribe: {
      status: {
        query: gql`
          subscription status($slideId: ID) {
            status: slideStatus(slideId: $slideId) {
              status {
                name
                color
                actions {
                  _id
                  name
                  priority
                  target {
                    _id
                  }
                }
              }
            }
          }
        `,
        result(data) {
          this.status = data.data.status.status;
        },
        variables() {
          return {
            slideId: this.$route.query.asset
          };
        }
      },
      blocked: {
        query: gql`
          subscription blocking($slideId: ID) {
            blocked: slideBlocked(slideId: $slideId) {
              isBlocked
            }
          }
        `,
        result(data) {
          this.blocked = data.data.blocked.isBlocked;
        },
        variables() {
          return {
            slideId: this.$route.query.asset
          };
        }
      }
    },
    status: {
      variables() {
        return {
          id: this.initialWorkflowStatus
        };
      },
      update: data => data.getWorkflowStatus,
      skip() {
        return !this.initialWorkflowStatus;
      },
      query: gql`
        query($id: ID!) {
          getWorkflowStatus(id: $id) {
            name
            color
            actions {
              _id
              name
              priority
              target {
                _id
              }
            }
          }
        }
      `
    }
  }
};
</script>

<style scoped>
.wrapper {
  overflow-x: scroll;
}
.meta {
  font-size: 11px;
  vertical-align: middle;
}
.spacer {
  width: 5px;
}
</style>
